import {
  annotationPropType,
  userPropType,
  proseMirrorNodePropType,
} from "./viewPropTypes";

export { annotationPropType, proseMirrorNodePropType, userPropType };
